module.exports = __webpack_public_path__ + "static/img/section02-01@w.eee32c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/samsung-svc/section02-01@w.jpg
// module id = NOJJ
// module chunks = 0